function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { getProductPath, getProductTypeById, getProductTypeLabel } from '@finect/front-resources/Products';
import { Link } from 'react-router-dom';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Rating } from '../../Rating';
import { Author } from '../ArticleCard/Author';
import { Inner, RatingContainer, ReviewTitle, ReviewBody, SubjectBlock } from './partials';
export var getProductReviewPath = function getProductReviewPath(product, review) {
  var productPath = getProductPath(product);
  return "".concat(productPath, "/reviews/").concat(review.id);
};
export var ReviewCard = function ReviewCard(_ref) {
  var review = _ref.review,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'a' : _ref$variant;
  var title = review.title,
    body = review.body,
    author = review.author,
    product = review.product;
  var productType = getProductTypeById(product.subtype);
  var productPath = getProductPath(product);
  var reviewPath = getProductReviewPath(product, review);
  var reviewLinkProps = {
    as: Link,
    to: reviewPath,
    rel: 'nofollow'
  };
  if (variant === 'b') {
    return React.createElement(Inner, null, React.createElement("div", null, React.createElement(SubjectBlock, {
      font: 0
    }, React.createElement(AppLink, {
      title: "Ir a la ficha del ".concat(getProductTypeLabel(productType, 'shortSingular', 'lowercase'), " ").concat(product.entity.displayName),
      href: productPath
    }, product.entity.displayName)), React.createElement(RatingContainer, null, React.createElement(Rating, {
      value: review.score,
      isSelectable: false,
      starSize: "20px",
      type: "infoStar"
    })), body ? React.createElement(ReviewBody, {
      lines: 1
    }, body.text) : null), React.createElement(Author, {
      iconSize: 2,
      withIcon: true,
      withOrganizationImage: true,
      author: _objectSpread(_objectSpread({}, author), {}, {
        subtype: 'user'
      }),
      marginTop: true
    }));
  }
  return React.createElement(Inner, null, React.createElement(Author, {
    iconSize: 2,
    withIcon: true,
    withOrganization: true,
    author: _objectSpread(_objectSpread({}, author), {}, {
      subtype: 'user'
    })
  }), React.createElement("div", null, React.createElement(SubjectBlock, null, React.createElement("span", null, "Opini\xF3n sobre el ", getProductTypeLabel(productType, 'shortSingular', 'lowercase'), " "), React.createElement(AppLink, {
    title: "Ir a la ficha del ".concat(getProductTypeLabel(productType, 'shortSingular', 'lowercase'), " ").concat(product.entity.displayName),
    href: productPath
  }, product.entity.displayName)), React.createElement(ReviewTitle, reviewLinkProps, title), React.createElement("div", null, React.createElement(Rating, {
    size: "small",
    value: review.score,
    isSelectable: false,
    starSize: "16px",
    type: "infoStar"
  }))));
};